import { createActivitiesHistoryQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useActivitiesHistoryQuery = createActivitiesHistoryQuery(HTTP_CONFIG.API.Consumer.url)
